import { graphql } from 'gql.tada';
import { client } from '../client';

export const createOrderlessReturnMutation = graphql(`
  mutation CreateOrderlessReturn($input: OrderlessClaimRequestInput!) {
    createOrderlessReturn(input: $input) {
      success
      errorResponse {
        errorCode
        errorMessage
        errorMessageDetail
        errorMessageDetailCode
      }
    }
  }
`);

export const createOrderlessReturnMutationFn = (
  input: CreateOrderlessReturnVariables['input'],
) => client.request(createOrderlessReturnMutation, { input });

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type CreateOrderlessReturnVariables =
  typeof createOrderlessReturnMutation extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T
    : never;

export type CreateOrderlessReturnResult =
  typeof createOrderlessReturnMutation extends import('gql.tada').TadaDocumentNode<
    infer R,
    any,
    any
  >
    ? R
    : never;
/* eslint-enable typescript/no-explicit-any */
